import { render, staticRenderFns } from "./RXProductView.vue?vue&type=template&id=922da520&"
import script from "./RXProductView.vue?vue&type=script&lang=ts&"
export * from "./RXProductView.vue?vue&type=script&lang=ts&"
import style0 from "./RXProductView.vue?vue&type=style&index=0&id=922da520&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports